;import $ from 'jquery';
window.$ = window.jQuery = $;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import 'jquery.scrollto';
import * as WaveSurfer from 'wavesurfer.js';
import confetti from 'canvas-confetti';
import './vendor/ba-debug.min.js';

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // Page constructor

    // Page constructor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // Global variables

        // GTM
        dataLayer: window.dataLayer || [],

        // CSRF
        csrf_token: $('meta[name="csrf-token"]').attr('content'),

        // Responsive breakpoints
        mobileMaxWidth: 767.98,
        tabletMaxWidth: 1199.98,

        // scrollTo
        scrollTo: {
            axis: 'y',
            duration: 300,
            offset: {
                left: 0,
                top: 0
            }
        },

        // lightGallery
        lightGallery: {
            selector: '.card',
            download: false,
            enableDrag: false,
            plugins: [lgVideo],
            autoplayFirstVideo: false,
            gotoNextSlideOnVideoEnd: false,
            youTubePlayerParams: {
                color: '#d70672',
                modestbranding: 1
            }
        },

        // wavesurfer
        wavesurfer: {
            backgroundColor: '#ffffff',
            barGap: 3,
            barRadius: 3,
            barWidth: 3,
            cursorColor: '#000000',
            cursorWidth: 1,
            progressColor: '#d70672',
            waveColor: '#eb82b8',
            normalize: true,
            responsive: true
        },

        // Memory game
        memoryGame: {
            shownFor: 1000,
            cards: 24,
            card: '<li class="tile init card card-memory"><div class="card-shadow"><div class="image"></div></div></li>',
            container: '.memory-game',
            deck: '.deck',
            movesClass: '.moves',
            minClass: '.min',
            secClass: '.sec',
            instruments: ['cintanyer', 'csello', 'csengo', 'csorgo', 'dob', 'fagott', 'fuvola', 'harfa', 'harmonika', 'harsona', 'hegedu', 'klarinet', 'kurt', 'nagybogo', 'oboa', 'szaxofon', 'timpani', 'triangulum', 'trombita', 'tuba', 'xilofon', 'zongora'],
        },

        // Online coloring book
        coloringBook: {
            canvas: '.canvas',
            colors: ['#ffffff', '#8e53a1', '#6abd46', '#71ccdc', '#f7ed45', '#f7daaf', '#ec2527', '#f16824', '#cecccc', '#5a499e', '#06753d', '#024259', '#fdd209', '#7d4829', '#931b1e', '#b44426', '#979797', '#c296c5', '#54b948', '#3c75bb', '#f7ed45', '#e89d5e', '#f26f68', '#f37123', '#676868', '#9060a8', '#169e49', '#3cbeb7', '#ffcd37', '#e5b07d', '#ef3c46', '#fdbe17', '#4e4d4e', '#6b449b', '#bacd3f', '#1890ca', '#fcd55a', '#d8c077', '#a62e32', '#f16a2d', '#343433', '#583e98', '#ba539f', '#9d2482', '#dd64a5', '#db778d', '#ec4394', '#e0398c', '#68af46', '#4455a4', '#fbee34', '#ad732a', '#d91e36', '#f99b2a'],
            container: '.online-coloring',
            palette: '.palette',
        },

        // Confetti
        confetti: {
            duration: 1000,
        },

        // Modal
        modal: {
            messages: false,
            title: false
        },

        // Animation
        animation: 300,

//------------------------------------------------------------------------------------------------------------------------
    // Application

        // Set layout
        setLayout: function(){
            // Load scrollTo
            window.Page.loadScrollTo();

            // Load galleries
            window.Page.loadGalleries();

            // Load memory game
            window.Page.loadMemory();

            // Load online coloring book
            window.Page.loadColoring();

            // Load quiz
            window.Page.loadQuiz();

            // Load modals
            window.Page.loadModals();

            // Load GTM
            //window.Page.loadGTM();
        },

        // Layout loaded
        layoutLoaded: function(){
        },

        // Resize layout
        resizeLayout: function(){
        },

//------------------------------------------------------------------------------------------------------------------------
    // Online coloring book

        // Load online coloring book
        loadColoring: function(params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.coloringBook, params);

            // Check game
            var $game = $(settings.container).first();
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            $game.data('coloringBook', settings);

            // Local variables
            settings.colorChosen = false;

            // Load SVG
            var $canvas = $(settings.canvas, $game);
            $canvas.load($game.data('id'), function(e){
                settings.painting = $('svg', $canvas);
                settings.shapes = $('g#Color', settings.painting).children();

                // Fill with color
                settings.shapes.on('click', function(e){
                    e.preventDefault();
                    window.Page.fillShape($game, $(this));
                });
            });

            // Add colors to palette
            var $palette = $(settings.palette, $game);
            if(!$palette.length){
                $game.append('<ul class="palette" />');
                $palette = $(settings.palette, $game);
            }
            $palette.empty();
            $.each(settings.colors, function(i, color){
                var $color = $('<li />').css({ backgroundColor: color });
                $palette.append($color.data('color', color));

            });

            // Choose first color
            window.Page.pickColor($game, $('li', $palette).first());

            // Pick color on click
            $palette.on('click', 'li', function(e){
                e.preventDefault();
                window.Page.pickColor($game, $(this));
            });

            // Random colors
            $game.on('click', 'button.btn-random:enabled', function(e){
                e.preventDefault();
                window.Page.fillRandom($game);
            });

            // Clear colors
            $game.on('click', 'button.btn-clear:enabled', function(e){
                e.preventDefault();
                window.Page.clearAll($game);
            });
        },

        // Pick color from palette
        pickColor: function($game, $color){
            if(!($game instanceof jQuery) || !$game.length || !($color instanceof jQuery) || !$color.length){
                return false;
            }
            var settings = $game.data('coloringBook');

            // Pick color from palette
            settings.colorChosen = $color.data('color');
            $('.color-active', $game).css({ backgroundColor: settings.colorChosen });
        },

        // Fill shape with color
        fillShape: function($game, $shape){
            if(!($game instanceof jQuery) || !$game.length || !($shape instanceof jQuery) || !$shape.length){
                return false;
            }
            var settings = $game.data('coloringBook');

            // Fill shape with color
            $shape.css({ fill: settings.colorChosen });
            if($shape.hasClass('background')){
                $shape.siblings('.background').css({ fill: settings.colorChosen });
            }
        },

        // Fill painting with random colors
        fillRandom: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('coloringBook');

            // Fill painting with random colors
            settings.shapes.each(function(i, shape){
                var color = settings.colors[Math.floor((Math.random() * settings.colors.length))];
                $(shape).css({ fill: color });
                if($(shape).hasClass('background')){
                    $(shape).siblings('.background').css({ fill: color });
                }
            });
        },

        // Clear all colors
        clearAll: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('coloringBook');

            // Clear all colors
            settings.shapes.each(function(i, shape){
                $(shape).css({ fill: '#ffffff' });
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Memory game

        // Load memory game
        loadMemory: function(params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.memoryGame, params);

            // Check game
            var $game = $(settings.container).first();
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            $game.data('memoryGame', settings);

            // Local variables
            settings.cardsShown = [];
            settings.cardsMatched = [];
            settings.moves = 0;
            settings.timer = 0;
            settings.gameOn = false;
            settings.gameTimer = null;

            // Hand out new cards
            window.Page.newHand($game);

            // Show cards on click
            $game.on('click', '.tile', function(e){
                e.preventDefault();
                window.Page.showCard($game, $(this));
            });

            // Restart game
            $game.on('click', 'button.btn-restart:enabled', function(e){
                e.preventDefault();
                window.Page.newHand($game);
            });
        },

        // Start timer
        startTimer: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Game is already finished
            if(settings.cards == settings.cardsMatched.length && !$('.card:not(.match)', $game).length){
                window.Page.stopTimer($game);
            }

            // Time is ticking
            if(settings.gameOn){
                return false;
            }

            // Start timer
            settings.gameOn = true;
            settings.timer = 0;
            clearInterval(settings.gameTimer);
            settings.gameTimer = setInterval(window.Page.tickTimer, 1000, $game);
        },

        // Stop timer
        stopTimer: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Stop timer
            settings.gameOn = false;
            settings.timer = 0;
            clearInterval(settings.gameTimer);
        },

        // Time is ticking
        tickTimer: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Tick
            settings.timer++;
            const zeroPad = (num, places) => String(num).padStart(places, '0');
            $(settings.minClass, $game).html(zeroPad(Math.floor(settings.timer / 60), 2));
            $(settings.secClass, $game).html(zeroPad(settings.timer % 60, 2));
        },

        // Show card
        showCard: function($game, $card){
            if(!($game instanceof jQuery) || !$game.length || !($card instanceof jQuery) || !$card.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Timer starts only on first click
            window.Page.startTimer($game);

            // Prevent showing more than two cards
            if(settings.cardsShown.length >= 2 || $card.is('.show, .match, :hidden')){
                return false;
            }

            // Flip card
            $card.addClass('show').removeClass('init');
            settings.cardsShown.push($card);

            // Two cards are shown
            if(settings.cardsShown.length == 2){
                // Increase moves
                $(settings.movesClass, $game).html(++settings.moves);
                // Match cards
                window.Page.matchCards($game);
            }
        },

        // Show card
        matchCards: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Check if there are two cards only
            if(settings.cardsShown.length !== 2 || !settings.cardsShown[0].is('.show:visible:not(.match)') || !settings.cardsShown[1].is('.show:visible:not(.match)')){
                return false;
            }

            // Matching
            if(settings.cardsShown[0].data('tile') === settings.cardsShown[1].data('tile')){
                for(let card of settings.cardsShown){
                    settings.cardsMatched.push(card.addClass('match'));
                }

                // Empty slots
                settings.cardsShown = [];

                // You won
                if(settings.cards == settings.cardsMatched.length && !$('.card:not(.match)', $game).length){
                    window.Page.endMemory($game);
                }
            }
            // Not matching
            else {
                // Wait for a second then shake the cards
                setTimeout(function(){
                    for(let card of settings.cardsShown){
                        card.addClass('shake')
                    }

                    // Flip the cards after shaking
                    setTimeout(function(){
                        for(let card of settings.cardsShown){
                            card.removeClass('show shake');
                        }

                        // Empty slots
                        settings.cardsShown = [];
                    }, window.Page.animation * 2);
                }, settings.shownFor);
            }
        },

        // You won
        endMemory: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Celebrating
            window.Page.startConfetti();

            // Stop timer
            window.Page.stopTimer($game);
        },

        // Hand out new cards
        newHand: function($game){
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }
            var settings = $game.data('memoryGame');

            // Reset game
            $(settings.movesClass, $game).html('0');
            $(settings.minClass, $game).html('00');
            $(settings.secClass, $game).html('00');
            settings.moves = 0;
            settings.cardsShown = [];
            settings.cardsMatched = [];
            settings.gameOn = false;
            settings.timer = 0;
            clearInterval(settings.gameTimer);

            // Shuffle instruments
            var instruments = window.Page.shuffle(settings.instruments);

            // Only one string and one wind instrument per set
            var strings = 0, winds = 0;
            for(var i = 0; i < instruments.length; i++){
                if(['hegedu', 'csello', 'nagybogo'].indexOf(instruments[i]) >= 0){
                    strings++;
                    if(strings > 1){
                        instruments.splice(instruments.indexOf(instruments[i]), 1);
                        i--;
                    }
                }
                else if(['fagott', 'fuvola', 'klarinet', 'oboa'].indexOf(instruments[i]) >= 0){
                    winds++;
                    if(winds > 1){
                        instruments.splice(instruments.indexOf(instruments[i]), 1);
                        i--;
                    }
                }
            }

            // Limit the number of instruments
            instruments = instruments.slice(0, Math.floor(settings.cards / 2));

            // Make pairs and shuffle them
            var tiles = instruments.concat(instruments);
            tiles = window.Page.shuffle(tiles);
            settings.cards = tiles.length;

            // Hand out cards
            var $deck = $(settings.deck, $game);
            if(!$deck.length){
                $game.append('<ul class="deck" />');
                $deck = $(settings.deck, $game);
            }
            $deck.empty();
            $.each(tiles, function(i, tile){
                var $tile = $(settings.card);
                $('.image', $tile).addClass('instrument-' + tile);
                $deck.append($tile.data('tile', tile));
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Confetti

        // Yaaay!
        startConfetti: function(params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.confetti, params);

            // Duration
            var end = Date.now() + settings.duration;

            // Confetti
            (function frame(){
                confetti({
                    particleCount: 10,
                    angle: 60,
                    spread: 55,
                    origin: { x: 0 },
                    shapes: ['square'],
                    //colors: settings.colors,
                });
                confetti({
                    particleCount: 10,
                    angle: 120,
                    spread: 55,
                    origin: { x: 1 },
                    shapes: ['square'],
                    //colors: settings.colors,
                });

                // Next frame
                if(Date.now() < end){
                    requestAnimationFrame(frame);
                }
            }());
        },

//------------------------------------------------------------------------------------------------------------------------
    // Quiz

        // Load quiz
        loadQuiz: function(){
            // Restart button
            $('.quiz').on('click', 'button.btn-restart:enabled', function(e){
                e.preventDefault();
                window.Page.restartQuiz($(this));
            });

            // Check game
            var $game = $('.quiz-content', '.quiz').first();
            if(!($game instanceof jQuery) || !$game.length){
                return false;
            }

            // Start with the next question or next trivia
            if($('.quiz-content', '.quiz').length){
                window.Page.nextQuestion();
            }

            // Answer button
            $('.quiz').on('click', 'button.btn-answer:enabled, .answer .image', function(e){
                e.preventDefault();
                e.stopPropagation();
                var $button = null;

                // Clickable thumbnail
                if($(this).is('.answer .image')){
                    if($(this).next('button.btn-answer:enabled').length){
                        $button = $(this).next('button.btn-answer:enabled');
                    }
                    else {
                        return false;
                    }
                }
                else {
                    $button = $(this);
                }

                // Send answer
                window.Page.sendAnswer($button);
            });

            // Disable contextmenu on videos
            $(document).on('contextmenu', 'video', function(e){
                return false;
            });

            // Next button
            $('.quiz').on('click', 'button.btn-next:enabled', function(e){
                e.preventDefault();
                window.Page.nextQuestion($(this));
            });
        },

        // Send answer
        sendAnswer: function($button){
            // Disable all buttons
            var $form = $button.closest('form');
            $('button.btn-answer', $form).prop('disabled', true);
            $('button.btn-next', $form).prop('disabled', true);
            $('.answer', $form).addClass('disabled');

            // AJAX
            $.ajax({
                url: $form.attr('action'),
                data: { questionId: $form.data('id'), answerId: $button.data('id'), '_token': window.Page.csrf_token },
                dataType: 'json',
                type: 'post',
                async: true,
                cache: false
            })
            // Response
            .done(function(data, textStatus, jqXHR){
                if(data.status === 'success' && typeof data.data === 'object'){
                    // Mark the correct answer
                    if(data.data.correctId){
                        $('button.btn-answer[data-id="' + data.data.correctId + '"]', $form).addClass('success');
                    }
                    // Show if our answer was incorrect
                    if(data.data.correctId !== data.data.answerId){
                        $('button.btn-answer[data-id="' + data.data.answerId + '"]', $form).addClass('fail');
                    }
                    // Correct answer
                    else {
                        // Success sound
                    }
                } else {
                    // Unexpected error modal
                    window.Page.showError('Váratlan hiba történt. (#JSA001)');
                }
            })
            // Error handling
            .fail(function(jqXHR, textStatus, errorThrown){
                if(typeof jqXHR.responseJSON === 'object'){
                    // Show error messages
                    window.Page.showError(jqXHR.responseJSON.message, jqXHR.responseJSON.errors);
                }
            })
            // Always
            .always(function(){
                // Enable Next button
                $('button.btn-next', $form).prop('disabled', false);
            });
        },

        // Next question
        nextQuestion: function($button){
            // If the function was invoked by a real button, then remove the active item
            if(typeof $button !== 'undefined' && $button instanceof jQuery){
                // There are still some items to be shown
                if($('.trivia:hidden', '.quiz').length || !$('.quiz-content', '.quiz').hasClass('shown')){
                    $('.trivia:visible', '.quiz').remove();
                    $('.quiz-content', '.quiz').hide();
                }
            }
            else {
                $('.quiz-content', '.quiz').hide();
                $('.trivia-container', '.quiz').hide();
                $('.trivia', '.trivia-container').hide();
            }

            // All remaining trivia and the quiz
            var $trivia = $('.trivia:hidden', '.quiz');
            var $quiz = $('.quiz-content:not(.shown)', '.quiz');
            var $next;

            // If there are trivia to be shown before the question
            if($trivia.filter('[data-after="0"]').length){
                $next = $trivia.filter('[data-after="0"]').sort((a,b) => $(a).data('order') - $(b).data('order')).first();
            }
            // If we had not shown the question yet
            else if($quiz.length){
                $next = $quiz.first();
            }
            // If there are trivia to be shown after the question
            else if($trivia.filter('[data-after="1"]').length){
                $next = $trivia.filter('[data-after="1"]').sort((a,b) => $(a).data('order') - $(b).data('order')).first();
            }
            // Reload the page for the next question
            else {
                window.location.reload();
                return false;
            }

            // Show trivia if there is one
            if($next.hasClass('trivia')){
                $('.quiz-content', '.quiz').hide();
                $('.trivia-container', '.quiz').show();
            }
            // Show quiz otherwise
            else if($next.hasClass('quiz-content')){
                $('.quiz-content', '.quiz').show();
                $('.trivia-container', '.quiz').hide();
                $next.addClass('shown');
            }

            // Show next item
            $next.show();

            // Load waveforms
            window.Page.loadWaveforms();
        },

        // Restart quiz
        restartQuiz: function($button){
            // AJAX
            $.ajax({
                url: $button.data('url'),
                type: 'get',
                async: true,
                cache: false
            })
            // Response
            .done(function(data, textStatus, jqXHR){
                if(data.status === 'success' && typeof data.data === 'object'){
                    // Reload the page
                    window.location.reload();
                } else {
                    // Unexpected error modal
                    window.Page.showError('Váratlan hiba történt. (#JRQ001)');
                }
            })
            // Error handling
            .fail(function(jqXHR, textStatus, errorThrown){
                if(typeof jqXHR.responseJSON === 'object'){
                    // Show error messages
                    window.Page.showError(jqXHR.responseJSON.message, jqXHR.responseJSON.errors);
                }
            })
        },

//------------------------------------------------------------------------------------------------------------------------
    // Waveforms

        // Load waveforms
        loadWaveforms: function(){
            // Load all waveforms
            $('.waveform').each(function(i, target){
                window.Page.loadWavesurfer($(target));
            });
        },

        // Load wavesurfer
        loadWavesurfer: function($target, params){
            if(!$target.is(':visible') || !$target.data('sound')) return false;

            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.wavesurfer, params);

            // Waveform settings
            settings.container = $target.get(0);
            settings.height = $target.height();

            // Load wavesurfer
            var wavesurfer = WaveSurfer.create(settings);
            $target.data('wavesurfer', wavesurfer);

            // Bind play button
            var $playButton = $('#' + $target.data('playbutton') + ':button:not(:disabled)');
            if($playButton.length){
                $playButton.on('click', function(e){
                    e.preventDefault();
                    wavesurfer.playPause();
                });
            }

            // Bind stop button
            var $stopButton = $('#' + $target.data('stopbutton') + ':button:not(:disabled)');
            if($stopButton.length){
                $stopButton.on('click', function(e){
                    e.preventDefault();
                    wavesurfer.stop();
                });
            }

            // Event handling
            wavesurfer.on('error', function(e){
                debug.warn('wavesurfer error', e);
            });
            wavesurfer.on('play', function(e){
                $('.fa-play', $playButton).addClass('d-none');
                $('.fa-pause', $playButton).removeClass('d-none');
            });
            wavesurfer.on('pause', function(e){
                $('.fa-play', $playButton).removeClass('d-none');
                $('.fa-pause', $playButton).addClass('d-none');
            });

            // Load audio and create waveform
            wavesurfer.load($target.data('sound'));
        },

//------------------------------------------------------------------------------------------------------------------------
    // lightGallery

        // Load galleries
        loadGalleries: function(){
            // Load all galleries
            $('.gallery').each(function(i, target){
                window.Page.loadGallery($(target));
            });
        },

        // Load gallery
        loadGallery: function($target, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.lightGallery, params);

            // Gallery settings
            if(settings.dynamic){
                settings.dynamicEl = $target.data('gallery');
            }

            // Load gallery
            var lightgallery = lightGallery($target.get(0), settings);
            $target.data('lightgallery', lightgallery);
        },

//------------------------------------------------------------------------------------------------------------------------
    // scrollTo

        // Load scrollTo
        loadScrollTo: function(){
            // CTA
            $(document).on('click', 'a[href^="#"], a[href^="' + window.location.origin + window.location.pathname + '#"]', function(e){
                e.preventDefault();
                window.Page.scrollToHash(this.hash);
            });

            // On load
            if(document.readyState === 'complete'){
                window.Page.scrollToHash(window.location.hash);
            }
            $(window).on('load', function(e){
                window.Page.scrollToHash(window.location.hash);
            });
        },

        // Scroll to content
        scrollToHash: function(hash, params){
            if(!/^\#[0-9a-z_-]+$/gi.test(hash) || !$(hash).is(':visible')) return false;

            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.scrollTo, params);

            // Offset by fixed navbar's height
            settings.offset.top = ($(window).width() > window.Page.tabletMaxWidth ? -$('header .navbar').outerHeight() : 0);

            // Close navbar on mobile view if open
            var $navbar = $('.navbar-collapse', 'header');
            if($navbar.hasClass('show')){
                // Scroll to content when navbar is closed
                $navbar.one('hidden.bs.collapse', function(e){
                    $(window).scrollTo(hash, settings);
                    window.location.hash = hash;
                });
                // Close navbar
                var bsCollapse = new bootstrap.Collapse($navbar.get(0), { toggle: false });
                bsCollapse.hide();
            }
            // Scroll to content immediately
            else {
                $(window).scrollTo(hash, settings);
                window.location.hash = hash;
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // GTM Event

        // Load GTM
        loadGTM: function(){
            // CTA
            $(document).on('click', '[data-event="click"]', function(e){
                window.Page.sendEvent($(this).data('event-action'), $(this).data('event-category'), $(this).data('event-label'));
            });

            // On load
            $('[data-event="callback"]').each(function(i, target){
                window.Page.sendEvent($(target).data('event-action'), $(target).data('event-category'), $(target).data('event-label'));
            });
        },

        // GTM Event
        sendEvent: function(action, category, label){
            window.Page.dataLayer.push({
                event: action,
                eventAction: action,
                eventCategory: category,
                eventLabel: label
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Modals

        // Load modals
        loadModals: function(){
            // Load modals
            $('.modal').each(function(i, target){
                var modal = new bootstrap.Modal($(target).get(0));

                // Show default modals
                if($(target).attr('data-show') == 'true'){
                    modal.show();
                }

                // Modal has been open
                $(target).on('shown.bs.modal', function(e){
                    // Bootstrap bugfix: losing autofocus in modals
                    $(':input[autofocus]:first', $(this)).focus();
                });
            });
        },

        // Show modal
        showModal: function(id, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Checking if modal exists
            var $modal = $('#modal-' + id);
            if(!$modal.length){
                return false;
            }
            var modal = bootstrap.Modal.getInstance($modal.get(0));
            if(!modal){
                modal = new bootstrap.Modal($modal.get(0));
            }

            // Substitute parameters
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).empty();
                if(typeof settings.errors !== 'undefined'){
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.errors);
                }
                else {
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.messages);
                }
            }

            // Show modal
            modal.show();
        },

        // Show error message
        showError: function(messages, errors){
            window.Page.showModal('error', { title: 'Hiba történt!', messages: messages, errors: errors });
        },

        // Append text array as paragraphs
        appendTextAsPs: function($target, text){
            if(!$target.length){
                return false;
            }

            // Convert variable to array
            text = typeof text !== 'undefined' ? text : [];
            if(text.constructor === String){
                text = [text];
            }
            else if(text.constructor === Array){
                text = text;
            }
            else if(typeof text === 'object'){
                var arr = [];
                $.each(text, function(i, value){
                    arr.push(value);
                });
                text = arr;
            }
            else {
                text = [];
            }

            // Append text
            $.each(text, function(i, line){
                $target.append($('<p />').html(line));
            });
        },

//------------------------------------------------------------------------------------------------------------------------
    // Helpers

        // Shuffle array
        shuffle: function(array){
            return array.map(value => ({ value, sort: Math.random() }))
                        .sort((a, b) => a.sort - b.sort)
                        .map(({ value }) => value);
        },

    };

//------------------------------------------------------------------------------------------------------------------------
    // Document ready

    // Document ready
    $(function(){
        // Set layout
        window.Page.setLayout();

        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window loaded

    // Window loaded
    $(window).on('load', function(e){
        // Resize layout
        window.Page.resizeLayout();

        // Layout loaded
        window.Page.layoutLoaded();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window resized or orientation changed

    // Window resized or orientation changed
    $(window).on('orientationchange resize', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window scrolled

    // Window scrolled
    $(window).on('scroll', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
